<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_73_1753)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.89543 0 0 0.895431 0 2L0 22C0 23.1046 0.895431 24 2 24L22 24C23.1046 24 24 23.1046 24 22L24 2C24 0.89543 23.1046 0 22 0L2 0Z" fill="#FC3400"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.00006 7.41427L14.6055 16.0198L6.70009 16.0198L6.70717 18.0209L18.0209 18.0209L18.0209 6.70717L16.0268 6.70717L16.0198 14.6055L7.41427 6.00006L6.00006 7.41427Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_73_1753">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
